<app-question-template [form]="form" [question]="question">
	@if (isV2()) {
		<div class="slider-v2">
			<div class="slider-v2-value">{{ model.value || "-" }}</div>
			<ion-range
				#slider
				class="slider-v2-range"
				(ionChange)="onChange(slider.value)"
				[value]="model.value"
				[step]="model.step"
				[min]="question.minimum"
				[max]="question.maximum"
				mode="ios"
				pin="true"
				[pinFormatter]="pinFormatter"
			></ion-range>
		</div>
	} @else {
		<div class="slider-value">{{ model.value || "-" }}</div>

		<ion-item>
			<ion-range
				#slider
				(ionChange)="onChange(slider.value)"
				[value]="model.value"
				[step]="model.step"
				[min]="question.minimum"
				[max]="question.maximum"
				mode="ios"
				pin="true"
				[pinFormatter]="pinFormatter"
			></ion-range>
		</ion-item>
	}
</app-question-template>
